import React, { useState, useEffect } from 'react';
import clsx from 'clsx';

import { Input } from '../Input/Input';
import { Icon } from '../Icon/Icon';

import styles from './SearchInput.module.scss';

type SearchInputProps = {
  className?: string;
  onChange: (value: string) => void;
  value?: string
  placeholder?: string
  parser?: (value: string) => string 
  showIcon?: boolean;
};

export const SearchInput: React.FC<SearchInputProps> = ({ className, placeholder, onChange, value, parser, showIcon = true }) => {
  const [searchValue, setSearchValue] = useState('');

  useEffect(() => {
    setSearchValue(value || '')
  }, [value])
  useEffect(() => {
    const timer = setTimeout(() => onChange(searchValue), 500);
    return () => clearTimeout(timer);
  }, [onChange, searchValue]);

  const onSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (parser) setSearchValue(parser(e.target.value))
    else setSearchValue(e.target.value);
  };

  return (
    <div className={clsx(styles.root, className)}>
      {showIcon ? <Icon className={styles.icon} name="search" /> : <></>}
      <Input
        type='search'
        className={styles.input}
        onChange={onSearchChange}
        value={searchValue}
        placeholder={placeholder}
      />
    </div>
  );
};
